import React, { useCallback, useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import { Link } from "react-router-dom";
import ReasonModal from "../ReasonModal";
import { useSelector } from "react-redux";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { Printer, Save2 } from "iconsax-react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./QcSpecification.css";
import QCSpecification from "./QCSpecification";
import logo from "../../assets/images/logo.png";

function View(props) {
  const { rowData, onBackClick } = props;
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");
  const [productSpecifications, setProductSpecifications] = useState([]);
  const [bomData, setBomData] = useState([]);
  const [updatedFinishGood, setUpdatedFinishGood] = useState({});
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state.userProfile.userProfile);

  useEffect(() => {
    if (rowData?.bom_screen && Array.isArray(rowData?.bom_screen)) {
      setBomData(rowData.bom_screen);
    }
  }, [rowData]);

  useEffect(() => {
    if (props.rowData?.id) {
      if (
        utils.hasPermission(
          primaryMenuRes,
          "Production Process",
          "production_process.specification"
        )
      ) {
        if (props.rowData?.qc_status !== "0") {
          getProductSpecifications(props.rowData?.id);
        }
      }
    }
  }, [props.rowData]);

  useEffect(() => {
    if (bomData.length > 0) {
      const initialFinishGoods = {};
      bomData
        .filter((item) => item.item_type === "finish_good")
        .forEach((item) => {
          initialFinishGoods[item.id] = {
            id: item.id,
            item_id: item.item_id,
            auto_qty: item.auto_qty,
            actual_qty: item.actual_qty ? item.actual_qty : item.auto_qty || "",
            remark: item.remark || "",
            unit_id: item.unit_id,
            item_type: item.item_type,
          };
        });

      setUpdatedFinishGood(initialFinishGoods);
    }
  }, [bomData]);

  const getProductSpecifications = (productId) => {
    utils
      .callAPI(
        "get",
        `/production/process/get-result-list?production_id=${productId}`
      )
      .then((res) => {
        if (Array.isArray(res)) {
          setProductSpecifications(res);
        } else {
          setProductSpecifications([]);
        }
      })
      .catch(() => {
        setProductSpecifications([]);
      });
  };

  const handleSavePDF = () => {
    const qcSpecElement = document.getElementById(
      "qc-specification-table-hidden"
    );
    if (qcSpecElement) {
      html2canvas(qcSpecElement, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        const topMargin = 20;
        pdf.addImage(imgData, "PNG", 0, topMargin, pdfWidth, pdfHeight);
        pdf.save(`${rowData?.product_name}_Specification.pdf`);
      });
    }
  };

  const rawMaterials = bomData.filter(
    (item) => item.item_type === "raw_material"
  );
  const finishGoods = bomData.filter(
    (item) => item.item_type === "finish_good"
  );
  const consumableItems = bomData.filter(
    (item) => item.item_type === "consumable_item"
  );

  const handleQtyChange = (item, value) => {
    setUpdatedFinishGood((prev) => ({
      ...prev,
      [item.id]: {
        ...prev[item.id],
        id: item.id,
        item_id: item.item_id,
        auto_qty: item.auto_qty,
        actual_qty: value,
        remark: item.remark || "",
        unit_id: item.unit_id,
        item_type: item.item_type,
      },
    }));
  };

  console.log(rowData);
  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow">
          <RB.Card.Header className="border-0">
            <h5>{rowData?.product_name} Details</h5>
            <div className="card-header-action">
              <Link className="btn btn-underline me-2" onClick={onBackClick}>
                Back
              </Link>
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
            <RB.Row className="mb-3">
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Product Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.product_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Batch No
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.batch_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Plant Location/Code
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.plant_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Batch Size
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.batch_size || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  R & D Status
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.RND_or_process_status === "1"
                    ? "Send for Approval"
                    : rowData.RND_or_process_status === "2"
                    ? "Approved"
                    : rowData.RND_or_process_status === "3"
                    ? "Rejected"
                    : "-"}
                </p>
              </RB.Col>
              {/* {rowData.RND_or_process_status === "3" && (
                <RB.Col md={3}>
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    R & D Reject Reason
                  </span>
                  <p className="fw-medium text-sm fw-semibold">
                    {rowData.reject_remark || "No reason provided"}
                  </p>
                </RB.Col>
              )} */}

              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  QC Status
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.qc_status === "0"
                    ? "Pending"
                    : rowData.qc_status === "1"
                    ? "Approved"
                    : rowData.qc_status === "2"
                    ? "Rejected"
                    : rowData.qc_status === "3"
                    ? "Correction"
                    : ""}
                </p>
              </RB.Col>
            </RB.Row>

            {(utils.hasPermission(
              primaryMenuRes,
              "Production Process",
              "batch_release.R&D_approve"
            ) ||
              utils.hasPermission(
                primaryMenuRes,
                "Production Process",
                "batch_release.R&D_reject"
              )) && (
              <RB.Row>
                <RB.Col xs={12}>
                  <h6>BOM Details</h6>
                  <div className="table-responsive">
                    <RB.Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>BOM Name</th>
                          <th>Item Name</th>
                          <th>Available Qty</th>
                          <th>Qty</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rowData.bom_recipe && rowData.bom_recipe.length > 0 ? (
                          rowData.bom_recipe.map((item) => (
                            <tr key={item.id}>
                              <td>{rowData.bom_name || "-"}</td>
                              <td>{item.product_name || "-"}</td>
                              <td>{item.available_stock || "-"}</td>
                              <td>{item.qty || "-"}</td>
                              <td>{item.status || "-"}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No BOM details available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </RB.Table>
                  </div>
                </RB.Col>
              </RB.Row>
            )}
            {rowData?.bom_screen && rowData?.bom_screen?.length !== 0 && (
              <RB.Row className="mt-4">
                {["raw_material", "finish_good", "consumable_item"].map(
                  (type) => {
                    const filteredItems = rowData.bom_screen.filter(
                      (item) => item.item_type === type
                    );
                    if (filteredItems.length === 0) return null;

                    return (
                      <RB.Col md={12} key={type} className="mb-4">
                        <h6>{type.replace("_", " ").toUpperCase()}</h6>
                        <div className="table-responsive">
                          <RB.Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>Item Code</th>
                                <th>Item Name</th>
                                <th>Auto Qty</th>
                                <th>Actual Qty</th>
                                <th>Unit</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredItems.map((item) => (
                                <tr key={item.id}>
                                  <td>{item.product_code}</td>
                                  <td>{item.product_name}</td>
                                  <td>{item.auto_qty}</td>
                                  <td>
                                    {type === "finish_good" ? (
                                      <>
                                        {rowData?.qc_status === "0" ? (
                                          <RB.Form.Control
                                            disabled={
                                              !utils.hasPermission(
                                                primaryMenuRes,
                                                "Production Process",
                                                "production_process.approve"
                                              )
                                            }
                                            type="number"
                                            min="0"
                                            step="any"
                                            value={
                                              updatedFinishGood[item.id]
                                                ?.actual_qty ?? item.actual_qty
                                            }
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (/^\d*\.?\d*$/.test(value)) {
                                                handleQtyChange(item, value);
                                              }
                                            }}
                                          />
                                        ) : (
                                          item.actual_qty
                                        )}
                                      </>
                                    ) : (
                                      item.actual_qty
                                    )}
                                  </td>
                                  <td>{item.unit_name}</td>
                                </tr>
                              ))}
                            </tbody>
                          </RB.Table>
                        </div>
                      </RB.Col>
                    );
                  }
                )}
              </RB.Row>
            )}

            {(utils.hasPermission(
              primaryMenuRes,
              "Production Process",
              "production_process.approve"
            ) ||
              utils.hasPermission(
                primaryMenuRes,
                "Production Process",
                "production_process.reject"
              ) ||
              utils.hasPermission(
                primaryMenuRes,
                "Production Process",
                "production_process.correction"
              )) && (
              <>
                {rowData?.qc_status === "0" && (
                  <QCSpecification
                    props={props}
                    updatedFinishGood={updatedFinishGood}
                  />
                )}
              </>
            )}

            {(utils.hasPermission(
              primaryMenuRes,
              "Production Process",
              "production_process.approve"
            ) ||
              utils.hasPermission(
                primaryMenuRes,
                "Production Process",
                "production_process.reject"
              ) ||
              utils.hasPermission(
                primaryMenuRes,
                "Production Process",
                "production_process.correction"
              )) && (
              <>
                {productSpecifications?.length !== 0 && (
                  <>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                      <h6>QC Specification</h6>

                      <RB.Button
                        className="btn ms-md-2"
                        onClick={handleSavePDF}
                        size="sm"
                      >
                        <Printer size="24" />
                      </RB.Button>
                    </div>
                    <hr className="hr-lg mt-1" />
                    <RB.Row className="mt-4" id="qc-specification-table">
                      <RB.Col md={2}>
                        <div>
                          <span className="text-uppercase fw-bold small text-body-secondary">
                            Product Name
                          </span>
                          <p className="fw-medium text-sm fw-semibold">
                            {rowData?.product_name}
                          </p>
                        </div>
                        <div>
                          <span className="text-uppercase fw-bold small text-body-secondary">
                            Batch No
                          </span>
                          <p className="fw-medium text-sm fw-semibold">
                            {rowData?.batch_no}
                          </p>
                        </div>
                        <div>
                          <span className="text-uppercase fw-bold small text-body-secondary">
                            MFG Month
                          </span>
                          <p className="fw-medium text-sm fw-semibold">
                            {moment().format("MMM-YYYY")}
                          </p>
                        </div>
                      </RB.Col>
                      <RB.Col md={10}>
                        <RB.Table striped bordered hover>
                          <thead>
                            <tr>
                              <th>TEST/PROPERTIES</th>
                              <th>SPECIFICATION</th>
                              <th>TEST RESULT</th>
                            </tr>
                          </thead>
                          <tbody>
                            {productSpecifications.map((spec) => (
                              <tr key={spec.id}>
                                <td>{spec.properties}</td>
                                <td>{spec.specification}</td>
                                <td className="mt-2">{spec?.test_result}</td>
                              </tr>
                            ))}
                          </tbody>
                        </RB.Table>
                      </RB.Col>
                    </RB.Row>
                  </>
                )}
              </>
            )}

            <RB.Row
              className="qc-specification-pdf"
              id="qc-specification-table-hidden"
            >
              <RB.Row md={3} className="d-flex justify-content-end">
                <img
                  src={logo}
                  className="img-fluid QcspecificationLogo"
                  alt="Logo"
                />
              </RB.Row>
              <RB.Row md={3} >
                <div>
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    Product Name
                  </span>
                  <p className="fw-medium text-sm fw-semibold">
                    {rowData?.product_name}
                  </p>
                </div>
                <div>
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    Batch No
                  </span>
                  <p className="fw-medium text-sm fw-semibold">
                    {rowData?.batch_no}
                  </p>
                </div>
                <div>
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    MFG Month
                  </span>
                  <p className="fw-medium text-sm fw-semibold">
                    {moment().format("MMM-YYYY")}
                  </p>
                </div>
              </RB.Row>
              <RB.Row md={8}>
                <div>
                  <table className="full-border-table">
                    <thead>
                      <tr>
                        <th>TEST/PROPERTIES</th>
                        <th>SPECIFICATION</th>
                        <th>TEST RESULT</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productSpecifications.map((spec) => (
                        <tr key={spec.id}>
                          <td>{spec.properties}</td>
                          <td>{spec.specification}</td>
                          <td>{spec?.test_result}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </RB.Row>
              <RB.Row className="mt-5 justify-content-end">
                <div className="px-4 text-end">
                  <p className="fw-bold mb-1">Signature By:</p>
                  <p className="fw-semibold">
                    {`${userProfile.firstName} ${userProfile.middleName} ${userProfile.lastName}`}
                  </p>
                  <p className="fst-italic small text-body-secondary mt-3">
                    This is a system-generated document and does not require a
                    physical signature.
                  </p>
                </div>
              </RB.Row>
            </RB.Row>
          </RB.Card.Body>
        </RB.Card>
      </div>

      <ReasonModal
        show={showModal}
        onHide={() => setShowModal(false)}
        title={modalTitle}
        text={modalText}
      />
    </>
  );
}

export default View;
